import Counter from './Counter';

const items = [
  [30, '+', 'Years of craftsmanship'],
  [4, '', 'Signature materials'],
  [100, '%', 'Focused on pavers'],
  [1, ' on 1', 'Personal consultation']
];

function TrustBar() {
  return (
    <div className="border-b border-ink/10 bg-bone">
      <div className="wrap grid grid-cols-2 gap-y-6 py-10 md:grid-cols-4">
        {items.map(([n, s, l]) => (
          <div key={l} className="md:border-l md:border-ink/10 md:pl-8 md:first:border-0 md:first:pl-0">
            <p className="h-display text-6xl text-brick">
              <Counter to={n} suffix={s} />
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-stone">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrustBar;
